import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "back-button" }

import Icon from "@/components/UI/Icon.vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'BackButton',
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Icon, {
      name: "arrow-left",
      size: 20,
      color: "#F5F5F5"
    })
  ]))
}
}

})